import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError, change } from 'redux-form';
import { toFromDates, convertUtcDate } from '../components/Common/cleanDates';
import moment from 'moment';

import {
  REQUEST_SALES_INVOICES,
  REQUEST_SALES_INVOICES_BY_NUM,
  FETCH_SALES_INVOICES_BY_NUM_SUCCESS,
  FETCH_SALES_INVOICES_BY_NUM_FAILURE,
  FETCH_SALES_INVOICES_SUCCESS,
  FETCH_SALES_INVOICES_FAILURE,
  SELECT_SALES_INVOICE,
  RESET_CURRENT_SALES_INVOICE,
  REQUEST_SALES_INVOICE_DETAIL,
  FETCH_SALES_INVOICE_DETAIL_SUCCESS,
  FETCH_SALES_INVOICE_DETAIL_FAILURE,
  REQUEST_FINALIZE_INVOICE,
  FINALIZE_INVOICE_SUCCESS,
  FINALIZE_INVOICE_FAILURE,
  REQUEST_FINALIZED_INVOICES,
  FETCH_FINALIZED_INVOICES_SUCCESS,
  FETCH_FINALIZED_INVOICES_FAILURE,
  UPDATE_SALES_INVOICE,
  UPDATE_SALES_INVOICE_SUCCESS,
  UPDATE_SALES_INVOICE_FAILURE,
  CLEAR_UPDATE_SALES_INVOICE,
  UPDATE_SALES_INVOICE_RESET,
  REQUEST_SALES_INVOICE_FORM,
  FETCH_SALES_INVOICE_FORM_SUCCESS,
  FETCH_SALES_INVOICE_FORM_FAILURE,
  REQUEST_SALES_INVOICES_COMPLETED,
  FETCH_SALES_INVOICES_COMPLETED_SUCCESS,
  FETCH_SALES_INVOICES_COMPLETED_FAILURE,
  REQUEST_CUSTOMER_ITEM,
  FETCH_CUSTOMER_ITEM_SUCCESS,
  FETCH_CUSTOMER_ITEM_FAILURE,
  REQUEST_VOID_INVOICE,
  VOID_INVOICE_SUCCESS,
  VOID_INVOICE_FAILURE,
  REQUEST_VOID_RETURN,
  VOID_RETURN_SUCCESS,
  VOID_RETURN_FAILURE,
  EDIT_SI_CUSTOMER,
  EDIT_SI_CUSTOMER_SUCCESS,
  EDIT_SI_CUSTOMER_FAILURE,
  RESET_EDIT_SI_CUSTOMER,
  REQUEST_UNPAID_INVOICE,
  FETCH_UNPAID_INVOICE_SUCCESS,
  FETCH_UNPAID_INVOICE_FAILURE,
  REQUEST_DELIVER_INVOICE,
  DELIVER_INVOICE_SUCCESS,
  DELIVER_INVOICE_FAILURE,
  // REQUEST_SALES_INVOICES_BY_DETAILS,
  // FETCH_SALES_INVOICES_BY_DETAILS_SUCCESS,
  // FETCH_SALES_INVOICES_BY_DETAILS_FAILURE
} from './type';

import {
  SALES_INVOICE_URL,
  SALES_INVOICE_NUM_URL,
  SALES_INVOICE_COMPLETED_URL,
  FINALIZED_INVOICES_URL,
  FINALIZE_INVOICE_URL,
  DELIVER_INVOICE_URL,
  SALES_INVOICE_UPDATE_URL,
  SALES_INVOICE_VOID_URL,
  SALES_RETURN_URL,
  FETCH_INVOICE_DETAIL_URL,
  FETCH_SALES_INVOICES_BY_TYPE_URL,
  REQUEST_SALES_INVOICE_FORM_URL,
  RELEASE_SALES_ORDER_URL,
  EDIT_SI_CUSTOMER_URL,
  UNPAID_SALES_INVOICE_URL,
  PATCH_INVOICE_EMPLOYEE_NOTE_URL,
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';

import { isGGI, isOCM, isVAK, isHO, isJRC } from './root_url';
// Inventories Actions

export function fetchSalesInvoices(
  type,
  postingDateGT,
  postingDateLT,
  Customer_id,
  days,
  status,
  orderSeller,
  productNum,
  isReport,
  orderType,
  filterParams
) {
  if (Customer_id != null && Customer_id != '') { Customer_id = `&Deliver_Customer_id=${Customer_id}`; } else { Customer_id = ''; }
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  if (status != null) { status = `&SaleStatus=${status}`; } else { status = ''; }

  let seller = orderSeller;
  let product = productNum;
  let report = isReport;

  if (seller) {
    seller = `&Sales_User_id=${seller}`;
  } else {
    seller = '';
  }

  if (product) {
    product = `&ProductNum=${product}`;
  } else {
    product = '';
  }

  if (isReport) {
    report = '&Report=true';
  } else {
    report = '&Report=false';
  }

  const orderTypeParms = {}
  if (isOCM) {
    orderTypeParms.IsTransfer = false;
    orderTypeParms.IsRelocation = false;
    if (orderType) {
      orderTypeParms[orderType] = true;
    } 
  }
  if (isHO || isJRC) {
    const paramsData = {
      'InvoiceNum': 'invoiceNum',
      'SONum': 'soNum',
      'CustomerNum': 'customerNum',
      'Customer_Name': 'customerName',
      'Sales_Username': 'salesUsername',
      'PaymentType': 'paymentType',
      'PaymentStatusRecord': 'paymentStatusRecord'
    }
    for (var key in filterParams) {
      orderTypeParms[paramsData[key]] = filterParams[key]
    }
  }

  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    const selectedWarehouse = state.header.selectedWarehouse;
    if (!selectedCompany || !selectedWarehouse) return;
    dispatch({ type: REQUEST_SALES_INVOICES });
    return axios.get(
      `${SALES_INVOICE_URL + type}?PostingDate__gte=${dates.fromDate
      }&PostingDate__lte=${dates.toDate}${Customer_id}${status}${seller}${product}${report}
      &Pickup_Warehouse_id_id=${selectedWarehouse.value}&Company_id=${selectedCompany.value}`,
      {
        params: {
          ...orderTypeParms,
        },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesInvoicesSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesInvoicesFailure(err));
      });
  };
}

export function fetchSalesInvoicesSuccess(salesInvoices) {
  return {
    type: FETCH_SALES_INVOICES_SUCCESS,
    payload: salesInvoices,
  };
}

export function fetchSalesInvoicesFailure(error) {
  return {
    type: FETCH_SALES_INVOICES_FAILURE,
    payload: error,
  };
}

export function fetchSalesInvoicesByNum(
  // type,
  postingDateGT,
  postingDateLT,
  // Customer_id,
  //days,
  // status
  InvoiceNum,
  customerid,
  Pickup_Warehouse_id_id
) {
  const dates = toFromDates(-1, postingDateGT, postingDateLT);
  if (postingDateGT != null && postingDateGT != '') { postingDateGT = `?PostingDate__gte=${dates.fromDate}`; } else { postingDateGT = ''; }

  if (postingDateLT != null && postingDateLT != '') { postingDateLT = `&PostingDate__lte=${dates.toDate}`; } else { postingDateLT = ''; }

  if (InvoiceNum != null && InvoiceNum != '') { InvoiceNum = `&InvoiceNum=${InvoiceNum}`; } else { InvoiceNum = ''; }
  // if (days != null && days > 0)
  //   days = days + "/";
  // else
  //   days = '';
  // if (status != null)
  //   status = '&SaleStatus=' + status;
  // else
  //   status = '';
  let url = SALES_INVOICE_NUM_URL + (customerid ? `${customerid}/` : '') + postingDateGT + postingDateLT + InvoiceNum
  if (isVAK) {
    if (Pickup_Warehouse_id_id != null && Pickup_Warehouse_id_id != '') { Pickup_Warehouse_id_id = `&Pickup_Warehouse_id_id=${Pickup_Warehouse_id_id}`; } else { Pickup_Warehouse_id_id = ''; }
    url += Pickup_Warehouse_id_id
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_INVOICES_BY_NUM });
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesInvoicesByNumSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesInvoicesByNumFailure(err));
      });
  };
}

export function fetchSalesInvoicesByNumSuccess(salesInvoices) {
  return {
    type: FETCH_SALES_INVOICES_BY_NUM_SUCCESS,
    payload: salesInvoices,
  };
}

export function fetchSalesInvoicesByNumFailure(error) {
  return {
    type: FETCH_SALES_INVOICES_BY_NUM_FAILURE,
    payload: error,
  };
}

export function fetchSalesInvoicesCompleted(
  postingDateGT,
  postingDateLT,
  CustomerNum,
  // InvoiceNum
) {
  const dates = toFromDates(-1, postingDateGT, postingDateLT);
  if (postingDateGT != null && postingDateGT != '') { postingDateGT = `?PostingDate__gte=${dates.fromDate}`; } else { postingDateGT = ''; }

  if (postingDateLT != null && postingDateLT != '') { postingDateLT = `&PostingDate__lte=${dates.toDate}`; } else { postingDateLT = ''; }

  if (CustomerNum != null) { CustomerNum += '/'; } else { CustomerNum = ''; }

  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_INVOICES_COMPLETED });
    return axios.get(
      SALES_INVOICE_COMPLETED_URL + CustomerNum + postingDateGT + postingDateLT,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesInvoicesCompletedSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesInvoicesCompletedFailure(err));
      });
  };
}

export function fetchSalesInvoicesCompletedSuccess(salesInvoices) {
  return {
    type: FETCH_SALES_INVOICES_COMPLETED_SUCCESS,
    payload: salesInvoices,
  };
}

export function fetchSalesInvoicesCompletedFailure(error) {
  return {
    type: FETCH_SALES_INVOICES_COMPLETED_FAILURE,
    payload: error,
  };
}

export function fetchSalesInvoiceCompletedDetail(pk) {
  if (arguments.length == 2) {
    return (dispatch) => {
      dispatch(requestSalesInvoiceCompletedDetail());
      return axios.get(
        `${SALES_INVOICE_COMPLETED_URL}?InvoiceNum=${pk}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
        .then((response) => {
          dispatch(fetchSalesInvoiceCompletedDetailSuccess(response));
        }, (err) => {
          if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex';
            return
          }
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          dispatch(fetchSalesInvoiceCompletedDetailFailure(err));
        });
    };
  }
  return (dispatch) => {
    dispatch(requestSalesInvoiceCompletedDetail());
    return axios.get(
      `${RELEASE_SALES_ORDER_URL}?pk=${pk}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesInvoiceCompletedDetailSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesInvoiceCompletedDetailFailure(err));
      });
  };
}

export function requestSalesInvoiceCompletedDetail() {
  return {
    type: REQUEST_SALES_INVOICE_DETAIL,
  };
}

export function fetchSalesInvoiceCompletedDetailSuccess(salesInvoiceDetail) {
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (salesInvoiceDetail.data.OrderDate) salesInvoiceDetail.data.OrderDate = convertUtcDate(salesInvoiceDetail.data.OrderDate);
  if (salesInvoiceDetail.data.ETADate) salesInvoiceDetail.data.ETADate = convertUtcDate(salesInvoiceDetail.data.ETADate);
  if (salesInvoiceDetail.data.ReceivedDate) salesInvoiceDetail.data.ReceivedDate = convertUtcDate(salesInvoiceDetail.data.ReceivedDate);

  return {
    type: FETCH_SALES_INVOICE_DETAIL_SUCCESS,
    payload: salesInvoiceDetail,
  };
}

export function fetchSalesInvoiceCompletedDetailFailure(error) {
  return {
    type: FETCH_SALES_INVOICE_DETAIL_FAILURE,
    payload: error,
  };
}

export function selectSalesInvoice(salesInvoice) {
  return dispatch => new Promise((resolve) => {
    dispatch({
      type: SELECT_SALES_INVOICE,
      payload: salesInvoice,
    });
    resolve();
  });
}

export function resetCurrentSalesInvoice() {
  return {
    type: RESET_CURRENT_SALES_INVOICE,
  };
}

export function resetCurrentSalesInvoicePromise() {
  return dispatch => new Promise((resolve) => {
    dispatch({
      type: RESET_CURRENT_SALES_INVOICE,
    });
    resolve();
  });
}

export function fetchSalesInvoicesByType(type) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_INVOICES });
    return axios.get(
      FETCH_SALES_INVOICES_BY_TYPE_URL + type,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesInvoicesSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesInvoicesFailure(err));
      });
  };
}

// export function fetchSalesInvoicesByDetails() {
//     return dispatch => {
//         dispatch(requestSalesInvoicesByDetails());
//         return axios.get(FETCH_INVOICE_DETAIL_URL + status + '/' + SalesInvoice_id,
//             {
//                 headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
//             }
//         )
//             .then(response => {
//                 dispatch(fetchSalesInvoicesByDetailsSuccess(response));
//             })
//             .catch(response => {
//                 dispatch(fetchSalesInvoicesByDetailsFailure(response));
//             })
//     }
// }
//
// export function requestSalesINvoicesByDetails() {
//     return {
//         type: REQUEST_SALES_INVOICES_BY_DETAILS
//     }
// }
//
// export function fetchSalesInvoicesByDetailsSuccess(Invoices) {
//     return {
//         type: FETCH_SALES_INVOICES_BY_DETAILS_SUCCESS,
//         payload: Invoices
//     }
// }
//
// export function fetchSalesInvoicesByDetailsFailure(error) {
//     return {
//         type: FETCH_SALES_INVOICES_BY_DETAILS_FAILURE,
//         payload: error
//     }
// }

export function fetchSalesInvoiceDetail(pk) {
  if (arguments.length == 2) {
    return (dispatch) => {
      dispatch(requestSalesInvoiceDetail());
      return axios.get(
        `${RELEASE_SALES_ORDER_URL}search/?InvoiceNum=${pk}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
        .then((response) => {
          dispatch(fetchSalesInvoiceDetailSuccess(response));
        }, (err) => {
          if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex';
            return
          }
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          dispatch(fetchSalesInvoiceDetailFailure(err));
        });
    };
  }
  return (dispatch) => {
    dispatch(requestSalesInvoiceDetail());
    return axios.get(
      FETCH_INVOICE_DETAIL_URL + pk,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesInvoiceDetailSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesInvoiceDetailFailure(err));
      });
  };
}

export function requestSalesInvoiceDetail() {
  return {
    type: REQUEST_SALES_INVOICE_DETAIL,
  };
}

export function fetchSalesInvoiceDetailSuccess(salesInvoiceDetail) {
  salesInvoiceDetail = salesInvoiceDetail.data;
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (salesInvoiceDetail.OrderDate) salesInvoiceDetail.OrderDate = convertUtcDate(salesInvoiceDetail.OrderDate);
  if (salesInvoiceDetail.ETADate) salesInvoiceDetail.ETADate = convertUtcDate(salesInvoiceDetail.ETADate);
  if (salesInvoiceDetail.ReceivedDate) salesInvoiceDetail.ReceivedDate = convertUtcDate(salesInvoiceDetail.ReceivedDate);
  return {
    type: FETCH_SALES_INVOICE_DETAIL_SUCCESS,
    payload: salesInvoiceDetail,
  };
}

export function fetchSalesInvoiceDetailFailure(error) {
  return {
    type: FETCH_SALES_INVOICE_DETAIL_FAILURE,
    payload: error,
  };
}

export function fetchFinalizedInvoices() {
  return (dispatch) => {
    dispatch(requestFinalizedInvoices());
    return axios.get(
      FINALIZED_INVOICES_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchFinalizedInvoicesSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchFinalizedInvoicesFailure(err));
      });
  };
}

export function requestFinalizedInvoices() {
  return {
    type: REQUEST_FINALIZED_INVOICES,
  };
}

export function fetchFinalizedInvoicesSuccess(response) {
  return {
    type: FETCH_FINALIZED_INVOICES_SUCCESS,
    payload: response,
  };
}

export function fetchFinalizedInvoicesFailure(error) {
  return {
    type: FETCH_FINALIZED_INVOICES_FAILURE,
    payload: error,
  };
}

export function updateSalesInvoice({
  DocumentDate,
  PONum,
  Sales_Invoice_Lines,
  PostingDate,
  InvoiceNum,
  CreateTime,
  InvoiceShipDate,
}, status, pk, PaymentType, PaymentNum, Notation) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SALES_INVOICE });
    return axios.put(
      `${SALES_INVOICE_UPDATE_URL + pk}/`,
      {
        DocumentDate,
        Notation,
        PaymentNum,
        PaymentType,
        PONum,
        Sales_Invoice_Lines,
        PostingDate,
        InvoiceNum,
        CreateTime,
        InvoiceShipDate,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(updateSalesInvoiceSuccess(response));
        // browserHistory.push('/salesInvoice/');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(updateSalesInvoiceFailure(err));
      });
  };
}

export function updateSalesInvoiceSuccess(salesInvoiceUpdated) {
  return {
    type: UPDATE_SALES_INVOICE_SUCCESS,
    payload: salesInvoiceUpdated,
  };
}

export function updateSalesInvoiceFailure(error) {
  return {
    type: UPDATE_SALES_INVOICE_FAILURE,
    payload: error,
  };
}

export function clearUpdateSalesInvoice() {
  return {
    type: CLEAR_UPDATE_SALES_INVOICE,
  };
}

export function updateSalesInvoiceReset() {
  return {
    type: UPDATE_SALES_INVOICE_RESET,
  };
}

export function finalizeInvoiceSuccess() {
  return {
    type: FINALIZE_INVOICE_SUCCESS,
  };
}

export function finalizeInvoiceFailure(error) {
  return {
    type: FINALIZE_INVOICE_FAILURE,
    payload: error,
  };
}

export function finalizeInvoice(salesInvoiceIdList) {
  return (dispatch) => {
    dispatch({ type: REQUEST_FINALIZE_INVOICE });
    return axios({
      method: 'put',
      url: `${FINALIZE_INVOICE_URL}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      data: {
        ids: salesInvoiceIdList,
      },
    })
      .then((response) => {
        dispatch(finalizeInvoiceSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(finalizeInvoiceFailure(err));
      });
  };
}

export function deliverInvoiceSuccess() {
  return {
    type: DELIVER_INVOICE_SUCCESS,
  };
}

export function deliverInvoiceFailure(error) {
  return {
    type: DELIVER_INVOICE_FAILURE,
    payload: error,
  };
}

export function deliverInvoice(salesInvoiceIdList) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DELIVER_INVOICE });
    return axios({
      method: 'put',
      url: `${DELIVER_INVOICE_URL}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      data: {
        ids: salesInvoiceIdList,
      },
    })
      .then((response) => {
        dispatch(deliverInvoiceSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(deliverInvoiceFailure(err));
      });
  };
}

function toBinaryString(data) {
  const ret = [];
  const len = data.length;
  let byte;
  for (let i = 0; i < len; i++) {
    byte = (data.charCodeAt(i) & 0xFF) >>> 0;
    ret.push(String.fromCharCode(byte));
  }

  return ret.join('');
}


export function printInvoice(pk) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_INVOICE_FORM });
    return axios.get(
      REQUEST_SALES_INVOICE_FORM_URL + pk,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        const newWindow = window.open(`data:application/pdf,${escape(response.data)}`);
        dispatch(fetchInvoiceFormSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchInvoiceFormFailure(err));
      });
  };
}

export function fetchInvoiceFormSuccess(response) {
  return {
    type: FETCH_SALES_INVOICE_FORM_SUCCESS,
    payload: response,
  };
}

export function fetchInvoiceFormFailure(error) {
  return {
    type: FETCH_SALES_INVOICE_FORM_FAILURE,
    payload: error,
  };
}

export function fetchCustomerItem(customerNum) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_ITEM });
    return axios.get(
      `${SALES_INVOICE_UPDATE_URL}customer/${customerNum}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerItemSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerItemFailure(err));
      });
  };
}

export function fetchUnpaidInvoicesSuccess(response) {
  return {
    type: FETCH_UNPAID_INVOICE_SUCCESS,
    payload: response,
  };
}

export function fetchUnpaidInvoicesFailure(error) {
  return {
    type: FETCH_UNPAID_INVOICE_FAILURE,
    payload: error,
  };
}

export function fetchUnpaidInvoices(custId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_UNPAID_INVOICE });
    return axios.get(
      `${UNPAID_SALES_INVOICE_URL}${custId}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchUnpaidInvoicesSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchUnpaidInvoicesFailure(err));
      });
  };
}

export function fetchCustomerItemSuccess(items) {
  return {
    type: FETCH_CUSTOMER_ITEM_SUCCESS,
    payload: items,
  };
}

export function fetchCustomerItemFailure(error) {
  return {
    type: FETCH_CUSTOMER_ITEM_FAILURE,
    payload: error,
  };
}

export function voidInvoice(pk) {
  return (dispatch) => {
    dispatch({ type: REQUEST_VOID_INVOICE });
    const token = localStorage.getItem('token');
    return axios({
      method: 'post',
      url: `${SALES_INVOICE_VOID_URL}${pk}/`,
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        dispatch(voidInvoiceSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(voidInvoiceFailure(err));
      });
  };
}

export function voidInvoiceSuccess() {
  return {
    type: VOID_INVOICE_SUCCESS,
  };
}

export function voidInvoiceFailure(error) {
  return {
    type: VOID_INVOICE_FAILURE,
    payload: error,
  };
}

export function voidReturnSuccess() {
  return {
    type: VOID_RETURN_SUCCESS,
  };
}

export function voidReturnFailure(error) {
  return {
    type: VOID_RETURN_FAILURE,
    payload: error,
  };
}

export function voidReturn(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_VOID_RETURN });
    const token = localStorage.getItem('token');
    return axios({
      method: 'post',
      url: `${SALES_RETURN_URL}${id}/void`,
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        dispatch(voidReturnSuccess(response));
      }, (err) => {
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex';
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(voidReturnFailure(err));
      });
  };
}

function editSICustomerSuccess() {
  return {
    type: EDIT_SI_CUSTOMER_SUCCESS,
  };
}

function editSICustomerFailure(error) {
  return {
    type: EDIT_SI_CUSTOMER_FAILURE,
    payload: error,
  };
}

export function editSICustomer(id, { Deliver_Customer_id, Deliver_CustomerDetail_id }) {
  return (dispatch) => {
    dispatch({ type: EDIT_SI_CUSTOMER });
    const token = localStorage.getItem('token');
    return axios({
      method: 'put',
      url: `${EDIT_SI_CUSTOMER_URL}${id}/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        Deliver_Customer_id,
        Deliver_CustomerDetail_id,
      },
    }).then((response) => {
      dispatch(selectSalesInvoice(response.data))
        .then(() => { dispatch(editSICustomerSuccess()); });
    }, (err) => {
      if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex';
        return
      }
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(editSICustomerFailure(err));
    });
  };
}

export function resetEditSICustomer() {
  return {
    type: RESET_EDIT_SI_CUSTOMER,
  };
}

export function setField(field, value) {
  return (dispatch) => {
    dispatch(change('salesInvoice', field, value));
  };
}

export function resetFormInputs() {
  return (dispatch) => {
    // dispatch(change('editSalesInvoice', 'Quantity', ''));
    dispatch(change('editSalesInvoice', 'UnitPrice', ''));
    dispatch(change('editSalesInvoice', 'ProductInformation', ''));
    dispatch(change('editSalesInvoice', 'Weight', ''));
    dispatch(change('editSalesInvoice', 'itemNotation', ''));
  };
}

export function resetIssueInputs() {
  return (dispatch) => {
    dispatch(change('customerIssueCredit', 'Quantity', ''));
    dispatch(change('customerIssueCredit', 'UnitPrice', ''));
    dispatch(change('customerIssueCredit', 'ProductInformation', ''));
    dispatch(change('customerIssueCredit', 'Weight', ''));
    dispatch(change('customerIssueCredit', 'itemNotation', ''));
    if(isGGI) {
      dispatch(change('customerIssueCredit', 'SmallUnitPrice', ''));
      dispatch(change('customerIssueCredit', 'ConvertNum', ''));
    }
  };
}

export function updateInvoiceEmployeeNote(invoice_id, employeeNoteText) {
  let output = {
    EmployeeNote: employeeNoteText
  }
  const url = `${PATCH_INVOICE_EMPLOYEE_NOTE_URL}${invoice_id}`;
  return (dispatch) => {
    return axios({
      method: 'patch',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/salesInvoice_actions.jsx